import React from "react";
import TenantsPanel from "@/components/TenantsPanel";

export default function AdminTenants() {
  return <TenantsPanel />;
}
